import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core';
import { Device } from '@capacitor/device'
import { StorageService } from './storage.service'
import { NetworkService } from './network.service'

const SLACK_WEBHOOK_URL = "https://hooks.slack.com/services/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"
const LEVEL_COLORS = {
  low: '#36a64f',
  medium: '#ffae42',
  critical: '#ff0000'
} as const;

@Injectable({
  providedIn: 'root',
})
export class SlackService {
  appVersion = '6.0.7';

  constructor(
    private http: HttpClient,
    private storage: StorageService,
    private networkService: NetworkService,
  ) {}

  public postText(text: string) {
    const postFunc = () => this.http.post(
      SLACK_WEBHOOK_URL,
      { text },
      {
        headers: {
          "Content-type": 'application/x-www-form-urlencoded'
        },
        responseType: 'text'
      }
    ).subscribe({
      complete: () => console.debug("Message posted to Slack"),
      error: (error) => console.error("Error while posting to Slack", error)
    })
    
    this.networkService.runWhenOnline(postFunc);
  }

  public postMarkdown(text: string, title: string, level: 'low' | 'medium' | 'critical' = 'low') {
    const postFunc = () => this.http.post(
      SLACK_WEBHOOK_URL,
      { attachments: [{ text, title, color: LEVEL_COLORS[level], mrkdwn_in: ['text'] }] },
      {
        headers: {
          "Content-type": 'application/x-www-form-urlencoded'
        },
        responseType: 'text'
      }
    ).subscribe({
      complete: () => console.debug("Message posted to Slack"),
      error: (error) => console.error("Error while posting to Slack", error)
    })
    
    this.networkService.runWhenOnline(postFunc);
  }

  public async postError(error, title, userData = null, level: 'low' | 'medium' | 'critical' = 'medium') {
    const textArray = [
      '-'.repeat(title.length * 1.3),
      ` - *App version* : \`${this.appVersion}\``,
      ' - *Refresh token in storage* : `' + (this.storage.getWorkosRefreshToken() !== null && this.storage.getWorkosRefreshToken() !== '') + '`',
      '*Error log*',
      '```',
      JSON.stringify(error, null, 2),
      '```',
      '*Device information*',
    ];

    const deviceInfo = await Device.getInfo();
    for (const [key, value] of Object.entries(deviceInfo)) {
      textArray.push(` - *${key}* : ${value}`);
    }

    textArray.push('', '*LocalStorage dump*');
    textArray.push('```');
    textArray.push(JSON.stringify(window.localStorage, null, 2));
    textArray.push('```');

    if (userData) {
      textArray.push('*User data :*');
      for (const [key, value] of Object.entries(userData)) {
        textArray.push(` - *${key}* : ${value}`);
      }
    }
    this.postMarkdown(textArray.join('\n'), title, level);
  }
}